import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Notification } from 'src/app/notification/models/notification.model';
import { NotificationActions, NotificationActionTypes } from '../_actions/notification.actions';
import { QueryParamsModel } from '../../_base/crud';

export interface NotificationState extends EntityState<Notification> {
  totalCount: number;
  query: QueryParamsModel;
  pageLoading: boolean;
  actionLoading: boolean;
  showInitWaitingMessage: boolean;
  error: any;
}

export const adapter: EntityAdapter<Notification> = createEntityAdapter<Notification>();

export const initialNotificationState: NotificationState = adapter.getInitialState({
  totalCount: 0,
  query: new QueryParamsModel({}),
  pageLoading: false,
  actionLoading: false,
  showInitWaitingMessage: true,
  error: null,
});

export function notificationReducer(
  state = initialNotificationState,
  action: NotificationActions,
): NotificationState {
  switch (action.type) {
    case NotificationActionTypes.ToggleNotificationsPageLoading:
      return { ...state, pageLoading: action.payload.pageLoading };

    case NotificationActionTypes.ToggleNotificationActionLoading:
      return { ...state, actionLoading: action.payload.actionLoading };

    case NotificationActionTypes.LoadNotificationsPage:
      return adapter.addMany(action.payload.notifications, {
        ...initialNotificationState,
        totalCount: action.payload.totalCount,
        query: action.payload.query,
        showInitWaitingMessage: false,
      });

    case NotificationActionTypes.CancelNotificationsPage:
      return { ...state, query: new QueryParamsModel({}) };

    case NotificationActionTypes.CreateNotification:
      return adapter.addOne(action.payload.notification, state);

    case NotificationActionTypes.UpdateNotification:
      return adapter.updateOne(action.payload.notification, state);

    case NotificationActionTypes.DeleteNotification:
      return adapter.removeOne(action.payload.id, state);

    case NotificationActionTypes.ThrowNotificationError:
      return {
        ...state,
        pageLoading: false,
        actionLoading: false,
        error: action.payload.error,
      };

    case NotificationActionTypes.ClearNotificationError:
      return { ...state, error: null };

    default:
      return state;
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
